import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import AuthContext from '../context/AuthContext';

const AdminHadees = () => {
  const { admin } = useContext(AuthContext);
  const [formData, setFormData] = useState({ arabic: '', urdu: '', english: '', reference: '' });
  const [message, setMessage] = useState('');
  
  // ✅ 1. Added missing state to track the Hadees ID
  const [currentHadeesId, setCurrentHadeesId] = useState(null);

  // ✅ 2. Moved BASE_URL to the top so all functions can see it
  const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  const getConfig = () => ({
    headers: { Authorization: `Bearer ${admin?.token}` }
  });

  // ✅ 3. Added fetch function to find the current Hadees ID
  const fetchLatest = async () => {
  try {
    const { data } = await axios.get(`${BASE_URL}/api/hadees`);
    if (data && data._id) {
      setCurrentHadeesId(data._id);
      // ✅ Populate the form with current data for easy editing
      setFormData({
        arabic: data.arabic || '',
        urdu: data.urdu || '',
        english: data.english || '',
        reference: data.reference || ''
      });
    }
  } catch (err) {
    console.error("Error fetching latest Hadees", err);
  }
};

  useEffect(() => {
    fetchLatest();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${BASE_URL}/api/hadees`, formData, getConfig());
      setMessage('✅ Hadees Updated Successfully!');
      setFormData({ arabic: '', urdu: '', english: '', reference: '' });
      fetchLatest(); // Refresh the ID for the delete button
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(`❌ Error: ${error.response?.data?.message || "Server Error"}`);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete the current Hadees?")) return;
    try {
      await axios.delete(`${BASE_URL}/api/hadees/${currentHadeesId}`, getConfig());
      setMessage('🗑️ Hadees Deleted Successfully!');
      setCurrentHadeesId(null); // Hide delete button
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage("❌ Error deleting Hadees");
    }
  };

  return (
    <div className="card shadow-sm mt-3">
      <div className="card-header bg-success text-white fw-bold d-flex justify-content-between align-items-center">
        <span><i className="bi bi-pencil-square me-2"></i> Update Daily Hadees</span>
        
        {/* ✅ Delete button now has an ID to work with */}
        {currentHadeesId && (
          <button onClick={handleDelete} className="btn btn-sm btn-danger">
            <i className="bi bi-trash"></i> Delete Current
          </button>
        )}
      </div>

      <div className="card-body">
        {message && (
          <div className={`alert ${message.includes('Error') ? 'alert-danger' : 'alert-success'}`}>
            {message}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-bold">Arabic Text</label>
            <textarea className="form-control" rows="2" dir="rtl" required 
              value={formData.arabic} onChange={(e) => setFormData({...formData, arabic: e.target.value})} 
              placeholder="Enter Arabic text..." style={{ fontFamily: 'Amiri, serif', fontSize: '1.4rem' }}></textarea>
          </div>
          
          <div className="mb-3">
            <label className="form-label fw-bold">Urdu Translation</label>
            <textarea className="form-control" rows="2" dir="rtl" required
              value={formData.urdu} onChange={(e) => setFormData({...formData, urdu: e.target.value})}
              placeholder="Urdu tarjuma..." style={{ fontFamily: 'Noto Nastaliq Urdu, serif' }}></textarea>
          </div>
          
          <div className="mb-3">
            <label className="form-label fw-bold">English Translation</label>
            <textarea className="form-control" rows="2" required
              value={formData.english} onChange={(e) => setFormData({...formData, english: e.target.value})}
              placeholder="English translation..."></textarea>
          </div>
          
          <div className="mb-3">
            <label className="form-label fw-bold">Reference</label>
            <textarea type="text" className="form-control" dir="rtl" required
              value={formData.reference} onChange={(e) => setFormData({...formData, reference: e.target.value})}
              placeholder="e.g. حیح بخاری، حدیث" style={{ fontFamily: 'Noto Nastaliq Urdu, serif'}}></textarea>
          </div>
          
          <button type="submit" className="btn btn-success w-100 fw-bold">
            Post Hadees
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminHadees;